import { EditNotePayloadType, PostNotePayloadType } from 'model/tasks.model';
import axios from '../core/axios';
import { ApiConstants } from './api-constants';

export class DealsService {
  static getDealTypes = async () => {
    return await (
      await axios.get(ApiConstants.DEALS_API.DEAL_TYPES.URL())
    ).data;
  };

  static getStages = async () => {
    return await (
      await axios.get(ApiConstants.DEALS_API.DEAL_STAGES.URL())
    ).data;
  };

  static getServicesByDealType = async (type: string) => {
    return await (
      await axios.get(ApiConstants.DEALS_API.SERVICES_BY_DEAL_TYPE.URL(type))
    ).data;
  };

  static getDealDropdowns = async (dealType: string) => {
    return await (
      await axios.get(ApiConstants.DEALS_API.DEAL_DROPDOWNS.URL(dealType))
    ).data;
  };

  static getPricebooks = async () => {
    return await (
      await axios.get(ApiConstants.DEALS_API.PRICEBOOKS.URL())
    ).data;
  };

  static getPricebookProducts = async (pricebookId: string) => {
    return await (
      await axios.get(ApiConstants.DEALS_API.PRICEBOOK_PRODUCTS.URL(pricebookId))
    ).data;
  };

  static getAllClients = async (clientName?: string) => {
    const params = clientName ? { clientName } : {};
    return await (
      await axios.get(ApiConstants.DEALS_API.ALL_CLIENTS.URL(), { params })
    ).data;
  };

  static createDeal = async (payload: any) => {
    return await (
      await axios.post(ApiConstants.DEALS_API.CREATE_DEAL.URL(), payload)
    ).data;
  };

  static getDealById = async (dealId: string) => {
    return await (
      await axios.get(ApiConstants.DEALS_API.GET_DEAL.URL(dealId))
    ).data;
  };

  static updateDeal = async (dealId: string, payload: any) => {
    return await (
      await axios.patch(ApiConstants.DEALS_API.UPDATE_DEAL.URL(dealId), payload)
    ).data;
  };

  static deleteDeal = async (dealId: string) => {
    return await (
      await axios.delete(ApiConstants.DEALS_API.DELETE_DEAL.URL(dealId))
    ).data;
  };

  static getDealsListView = async (queryParams: any) => {
    return await (
      await axios.get(ApiConstants.DEALS_API.LIST_VIEW.URL(), {
        params: queryParams,
      })
    ).data;
  };

  static getKanbanView = async (queryParams: any) => {
    const response = await axios.get(ApiConstants.DEALS_API.KANBAN.URL(), {
      params: queryParams,
    });
    return response?.data;
  };

  static getMultiPipelineKanbanView = async (queryParams: any) => {
    const response = await axios.get(ApiConstants.DEALS_API.MULTI_PIPELINE_KANBAN.URL(), {
      params: queryParams,
    });
    return response?.data;
  };

  static getDealActivity = async (dealId: string, limit: number = 20, offset: number = 0) => {
    return await (
      await axios.get(ApiConstants.DEALS_API.DEAL_ACTIVITY.URL(), {
        params: { dealId, limit, offset },
      })
    ).data;
  };

  static getMembers = async () => {
    return await (
      await axios.get(ApiConstants.DEALS_API.MEMBERS.URL())
    ).data;
  };

  static getRollupNumbers = async (queryParams: any) => {
    return await (
      await axios.get(ApiConstants.DEALS_API.ROLLUP_NUMBER.URL(), {
        params: queryParams,
      })
    ).data;
  };

  static getNotes = async (dealId: string) => {
    return await (
      await axios.get(ApiConstants.DEALS_API.GET_NOTES.URL(dealId))
    ).data;
  };

  static postNote = async (payload: PostNotePayloadType) => {
    return await (
      await axios.post(ApiConstants.DEALS_API.POST_NOTE.URL(), payload)
    ).data;
  };

  static editNote = async (payload: EditNotePayloadType) => {
    return await (
      await axios.patch(ApiConstants.DEALS_API.PATCH_NOTE.URL(), payload)
    ).data;
  };

  static deleteNote = async (noteId: string) => {
    return await (
      await axios.delete(ApiConstants.DEALS_API.DELETE_NOTE.URL(noteId))
    ).data;
  };
}
